export const state = {
  chatDialog: null,
  chatDetails: null,
  patientProviderDetails: null,
  chatConnected: sessionStorage.getItem('chatInProgress')
    ? sessionStorage.getItem('chatInProgress')
    : false,
  message: [],
  loading: false,
  providerResponse: true,
}
let timer

export const getters = {
  getChatDialogStatus: (state) => {
    if (state.chatDialog && state.chatDialog.component === 'chat') {
      clearInterval(timer)
    }
    if (state.chatDialog && state.chatDialog.component === '') {
      sessionStorage.setItem('chatInProgress', false)
    }
    return state.chatDialog ? state.chatDialog : null
  },
  getChatDetails: (state) => {
    return state.chatDetails ? state.chatDetails : null
  },
  getMessage: (state) => {
    return state.message.length ? state.message : []
  },
  getPatientProviderDetails: (state) => {
    return state.patientProviderDetails ? state.patientProviderDetails : null
  },
  getProviderResponseStatus: (state) => {
    return state.providerResponse
  },
}

export const mutations = {
  SET_CHAT_DIALOG_STATUS(state, newValue) {
    state.chatDialog = newValue
  },
  SET_CHAT_DETAILS(state, newValue) {
    state.chatDetails = newValue
  },
  SET_CHAT_MESSAGE(state, newValue) {
    state.message = [...state.message, newValue]
  },
  SET_PATIENT_PROVIDER_DETAILS(state, newValue) {
    state.patientProviderDetails = newValue
  },
  SET_CONNECTION_STATUS(state, newValue) {
    state.chatConnected = newValue
  },
  CLEAR_MESSAGE(state, newValue) {
    state.message = []
  },
  SET_LOADING_STATUS(state, newValue) {
    state.loading = newValue
  },
  SET_PROVIDER_RESPONSE_STATUS(state, newValue) {
    state.providerResponse = newValue
  },
}

export const actions = {
  setChatDialogStatus({ commit, state }, payload) {
    if (payload) {
      commit('SET_CHAT_DIALOG_STATUS', payload)
      return payload
    }
    return null
  },
  setChatMessage({ commit, state }, payload) {
    if (payload) {
      commit('SET_CHAT_MESSAGE', payload)
      return payload
    }
    return null
  },
  setConnectionStatus({ commit, state }, payload) {
    commit('SET_CONNECTION_STATUS', payload)
    sessionStorage.setItem('chatInProgress', payload)
    if (payload === false) {
      commit('CLEAR_MESSAGE', [])
    }
  },
  setInactiveStatus({ commit, state }, payload) {
    commit('SET_CONNECTION_STATUS', payload)
    sessionStorage.setItem('chatInProgress', payload)
  },
  async setChatDetails({ commit, state }, payload) {
    if (payload.Position) {
      commit('SET_CHAT_DETAILS', payload)
    } else {
      commit('SET_PATIENT_PROVIDER_DETAILS', payload)
    }
    // console.log(payload);
    // timer = await setInterval(() => {
    //   peerCoachingService.postStartChatDetails(payload).then((response) => {
    //     if (response.status === 200) {
    //       commit('SET_CHAT_DETAILS', response.data)
    //       return response.data
    //     }
    //   })
    // }, 20000)
  },
  setLoadingStatus({ commit, state }, payload) {
    commit('SET_LOADING_STATUS', payload)
  },
  setProviderResponseStatus({ commit, state }, payload) {
    commit('SET_PROVIDER_RESPONSE_STATUS', payload)
  },
}
